import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import i18nMap from 'src/mapping/i18nMap.json';
import { useDashboardServicesStore } from 'src/models/useDashboardServicesModel';
import { generateRedirectUrlToLog } from 'src/pages/Log/shared';
import { getServiceNamesByValues } from 'src/utils/service';
import { formatTableCounts, replaceTableData } from 'src/utils/table';

import { ThreatType } from '../../../../utils/enums';
import Percent from '../../Charts/Percent';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

function SecurityRiskMalwareDetection(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '20%', grow: 2, align: 'left', tooltip: true },
    { width: '12%', grow: 1, align: 'right' },
    { width: '12%', grow: 1, align: 'right' },
    { width: '10%', grow: 1, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.detectedBy'),
    t(`dashboard.chart.column.last${props.day}`),
    t(`dashboard.chart.column.prev${props.day}`),
    t('dashboard.chart.column.change'),
  ];

  const malwareDetectionMap = new Map<string, string>(
    Object.entries(i18nMap['malwareDetection'].frontendMap)
  );

  const data = formatTableCounts(
    props.data?.securityRiskScanDetectedBy?.[props.day],
    props.data?.securityRiskScanDetectedByPrevious?.[props.day]
  ).map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'securityFilterName',
              values: [SecurityFilterName.MalwareScanning],
              type: 'terms',
            },
            {
              field: 'threatType',
              values: [
                ThreatType.MaliciousFile,
                ThreatType.Ransomware,
                ThreatType.SuspiciousObjectType,
              ],
              type: 'terms',
            },
            {
              field: 'malwareDetectedBy',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    row[2],
    <Percent n={row[row.length - 1]} />,
  ]);

  replaceTableData(data, malwareDetectionMap, 0, t);

  return (
    <DashboardCard title={t('dashboard.chart.title.atpMalwareDetection')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(SecurityRiskMalwareDetection);
